import { AmountUtils, DateUtils } from '@shared/utils';
import type { StatementsResponse } from '@shared/api/rest/statements';
import { Button, Icon, Spinner, Table, TableCellType } from '@shared/widgets';
import DownloadIcon from '@assets/icons/download.svg';

interface Props {
  isLoading?: boolean;
  statements: StatementsResponse[];
  downloadingIds: string[];
  onDownloadStatement: (statement: StatementsResponse) => void;
}

export const AccountTable = (props: Props) => {
  return (
    <Table
      isLoading={props.isLoading}
      columns={['Date', 'Balance due', 'Account number', 'Account label', 'Account owner']}
      items={props.statements.map((x) => {
        const isLoading = props.downloadingIds.includes(x.statementId);
        return [
          {
            type: TableCellType.Text,
            value: DateUtils.formatDate(x.date),
            key: `date-${x.statementId}`,
          },
          {
            type: TableCellType.Text,
            value: AmountUtils.transformToAmountWithCurrency(x.balanceDue, x.currency),
            key: `balance-${x.statementId}`,
          },
          {
            type: TableCellType.Text,
            value: x.accountNumber,
            key: `accountNumber-${x.statementId}`,
          },
          {
            type: TableCellType.Text,
            value: x.label,
            key: `label-${x.statementId}`,
          },
          {
            type: TableCellType.Text,
            value: x.accountOwner,
            key: `accountOwner-${x.statementId}`,
          },
          {
            type: TableCellType.Custom,
            value: (
              <Button disabled={isLoading} onClick={() => props.onDownloadStatement(x)}>
                {isLoading ? <Spinner embedded /> : <Icon icon={<DownloadIcon />} />}
              </Button>
            ),
            key: `download-${x.statementId}`,
          },
        ];
      })}
    />
  );
};
